import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import {
  buildAutocompleteQueryConfig,
  buildSearchOptionsFromConfig,
  getConfig,
  buildFacetConfigFromConfig
} from "./faq-config-helper";
import appConfig from "../../config";

const { hostIdentifier, searchKey, endpointBase, engineName } = getConfig();
const connector = new AppSearchAPIConnector({
  searchKey,
  engineName,
  hostIdentifier,
  endpointBase
});

// [Autocomplete Query Config](https://github.com/elastic/search-ui/blob/master/ADVANCED.md#searchbox)
const config = {
  searchQuery: {
    filters: [
      { field: "language_code", values: [appConfig.appLanguage] } // ja, kr, sg, eu, us, cn
    ],
    facets: buildFacetConfigFromConfig(),
    ...buildSearchOptionsFromConfig()
  },
  trackUrlState: false,
  autocompleteQuery: buildAutocompleteQueryConfig(),
  apiConnector: connector,
  initialState: {
    resultsPerPage: 10
  }
};

export default config;
